import styled from 'styled-components';
import { IoBookmark } from 'react-icons/io5';
import { Badge } from 'reactstrap';
import { getProps } from './QueueTag/assets';

export const IconMarked = styled(IoBookmark)`
  color: ${(props) => (props.isSaved ? '#0f172a' : '#fff')};
  cursor: pointer;
  transition: color 0.2s ease, transform 0.15s ease;
  z-index: 999;

  &:hover {
    color: #4d525e;
    transform: scale(1.1);
  }

  &:active {
    transform: scale(1.2);
    transition: transform 0.08s ease;
  }
`;

export const SearchChatsZone = styled.div`
  position: relative;
  margin: 1rem 0;
`;

export const Content = styled.div`
  background: #fff;
  border-radius: 5px 5px 0 0;
  height: 100%;

  .DropdownMenu {
    height: auto;
    max-height: 400px;
    width: 280px;
    overflow-y: scroll;
  }

  @media screen and (min-width: 767px) {
    .DropdownMenu {
      margin-right: 250px;
    }
  }

  .MainLink {
    white-space: nowrap;
    border: transparent;
  }

  .nav-link {
    cursor: pointer;
    border: transparent;
  }

  .nav-link.active {
    ${(props) =>
      props.primaryColor && `border-bottom: 2px solid ${props.primaryColor};`}
  }

  .nav-link:hover {
    ${(props) =>
      props.primaryColor && `border-bottom: 2px solid ${props.primaryColor};`}
  }

  ul.scroll-menu {
    background-color: 'black';
  }

  .tab-content {
    height: calc(100% - 170px);
  }
`;

export const TimeZone = styled.h4`
  font-size: 14px;
`;

export const Header = styled.div`
  height: auto;

  @media (max-width: 304px) {
    height: 130px;
  }
`;

export const TopHeader = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 100%;
  background-color: red;
`;

export const IconCount = styled.div`
  margin-left: 10px;
  ${(props) =>
    props.primaryColor && `border: 4.5px solid ${props.primaryColor};`}
  border-radius: 50%;
  height: 3.125rem;
  width: 3.125rem;
  min-width: 3.125rem;
  display: flex;
  justify-content: center;
  align-items: center;

  & > h3 {
    font-size: ${(props) => props.count};
    font-weight: 500;
    margin-bottom: 0;
  }
`;

export const SubHeader = styled.div`
  justify-content: center;
  display: flex;
  width: max-content;

  & ul {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
  }

  & li {
    display: flex;
    flex-wrap: nowrap;
  }
`;

export const Hr = styled.hr`
  margin-top: -0.1px;
`;

export const IconName = styled.div`
  width: 55px;
  height: 55px;
  text-align: center;
  font-size: 30px;
  font-weight: 400;
  padding-top: 2px;
  color: white;
  border-radius: 50%;
  z-index: 99;

  ${(props) => props.color && `background-color: ${props.color};`}
  ${(props) => props.borderColor && `border-color: ${props.borderColor};`}
`;

export const MessageReceived = styled.div`
  display: flex;
  width: 60px;
  height: 21px;
  margin-left: auto;
  align-items: center;
  justify-content: flex-end;
  flex-direction: row;
`;

export const SaveChatZone = styled.div`
  display: flex;
  width: 60px;
  height: 32px;
  margin-left: auto;
  align-items: end;
  justify-content: flex-end;
  flex-direction: row;
`;

export const MessageCount = styled.div`
  width: 20px;
  height: 20px;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  background-color: #d9534f;
  border-radius: 50%;
  color: white;
  z-index: 100;
`;

const getColorByType = (type) => {
  switch (type) {
    case 'AgentWarning':
      return '#eab308';
    case 'AgentCritical':
      return '#dc2626';
    default:
      return '#292b2c';
  }
};

const getColorByTypeClient = (type, situation) => {
  switch (type) {
    case 'CustomerWarning':
      return '#eab308';
    case 'CustomerCritical':
      return '#dc2626';
    default:
      return getProps(situation)?.color;
  }
};

export const AlertZoneIcon = styled.div`
  display: flex;
  width: 20px;
  height: 20px;
  background-color: ${(props) => getColorByType(props.type)};
  border-radius: 0.4rem;
  align-items: center;
  justify-content: center;
  margin-left: 0.2rem;
`;

export const AlertClientBadge = styled(Badge)`
  background-color: ${(props) =>
    getColorByTypeClient(props.type, props.situation)};
  color: #fff;
`;

export const ExternalZoneCardChat = styled.div`
  cursor: pointer;
  width: 100%;
  min-width: 308px;
  height: 138px;
  display: flex;
  justify-content: flex-start;
  margin: 0;
  border-radius: 4px;
  padding: 0.5rem;
  background-color: ${(props) =>
    props.isSelected
      ? 'rgba(59, 130, 246, 0.15)'
      : props.isInAttendance
      ? 'rgba(114, 114, 114, 0.1)'
      : 'transparent'};

  &:hover {
    background-color: ${(props) =>
      props.isSelected
        ? 'rgba(59, 130, 246, 0.25)'
        : 'rgba(114, 114, 114, 0.15)'};
  }

  box-shadow: ${(props) =>
    props.isSelected ? '0 2px 8px rgba(0, 0, 0, 0.12)' : 'none'};
`;

export const QueueColorZone = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  margin-bottom: 0.4rem;
  height: 100%;
  width: 4px;
  max-width: 6px;
  border-radius: 4px;
  opacity: 0.7;
  background-color: ${(props) => props.color};
`;

export const TagZone = styled.div`
  display: flex;
  flex-direction: row;
`;

export const TagBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const NameZone = styled.div`
  display: flex;
  white-space: nowrap;
  width: 140px;
  overflow: hidden;
  align-items: center;
  justify-content: flex-start;
  margin-right: 0.3rem;
  margin-bottom: 0.7rem;
`;

export const NameCustomer = styled.h6`
  white-space: nowrap;
  font-size: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 2px;
  margin-bottom: 0;
`;

export const ChannelZone = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const QueueName = styled.h6`
  white-space: nowrap;
  width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ChannelName = styled.h6`
  white-space: nowrap;
  width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const BodyLeftZone = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 1rem;
`;

export const LeftZone = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;

export const RightZone = styled.div`
  text-align: right;
  padding: 10px;
`;
